import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import '../config.js';

import { theme, createFormData, sortObj } from '../services/helper.js';
import { alertService } from '../services/alert.service.js';
import ClientListItem from '../components/clientListItem.js';
import Progress from '../components/progress.js';
import { Paginator } from '../components/paginator.js';
import Sort from '../components/sort.js';

function Clients() {
  const [search, setSearch] = useState('');
  const [sortBy, setSortBy] = useState('first_name');
  const [sortOrder, setSortOrder] = useState(true);
  const [searchType, setSearchType] = useState('all');
  const [clients, setClients] = useState([]);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [filterTotal, setFilterTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  
  let createForm = useRef();
  let formData = {};

  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    formData[name] = value;
  }

  const checkHandleSearch = (e) => {
    if (e.key === 'Enter') {
      handleSearch(e);
    }
  }
  
  const handleSearch = (event) => {
    fetchClients(sortBy, sortOrder, 0, search, searchType);
  }

  const updateSortParam = (e, field) => {
    let newSearchOrder = true;
    if(field === sortBy){
      newSearchOrder = !sortOrder;
    }else{
      setSortBy(field);
    }
    setSortOrder(newSearchOrder);
    fetchClients(field, newSearchOrder, 0, search, searchType);
  }
  
  const resetSearch = (event) => {
    setSearch('');
    setSearchType('all');
    fetchClients(sortBy, sortOrder, 0, null, 'all');
  }

  const fetchClients = (pSortBy, pSortOrder, pPage, pSearch, pSearchType) => {
    let q = "";
    if(pSearch){
      if(pSearchType === 'all'){
        q = "q="+pSearch+"&";
      }else{
        q = "q="+pSearchType+":"+pSearch+"&";
      }
    }
    let order = 'desc';
    if(pSortOrder){
      order = 'asc';
    }
    let uri = global.config.api_server+'clients?limit='+global.config.items_per_page+'&page='+pPage+'&orderBy='+pSortBy+'&order='+order+'&'+q+'token='+localStorage.getItem("token");
    axios.get(uri)
    .then(res => {
      if(res.status === 200 && res.data.status === "success"){
        setClients(res.data.clients);
        setTotal(res.data.total);
        setFilterTotal(res.data.filterTotal);
        setLoading(false);
      }
    }).catch(err => {
      alertService.error(err);
    });
  }
  
  const handleSubmit = (event) => {
    event.preventDefault();
    if(formData.first_name && formData.last_name && formData.email && formData.mobile && formData.dob && formData.pan && formData.city && formData.state && formData.pincode && formData.address){
      setLoading(true);
      if(formData.salutation === undefined){
        formData.salutation = "Mr.";
      }
      if(formData.type === undefined){
        formData.type = "FIT";
      }
      axios.post(global.config.api_server+'client',createFormData({
        first_name: formData.first_name,
        last_name: formData.last_name,
        middle_name: formData.middle_name,
        email: formData.email,
        mobile: formData.mobile,
        salutation: formData.salutation,
        type: formData.type,
        dob: formData.dob,
        anniversary: formData.anniversary,
        pan: formData.pan,
        gst: formData.gst,
        city: formData.city,
        address: formData.address,
        state: formData.state,
        pincode: formData.pincode,
        task:"create",
        token: localStorage.getItem("token")
      })).then(res => {
        if(res.status === 200 && res.data.status === "success"){
          alertService.success('New client created');
          setTimeout(function(){
            window.location.reload();
          }, 1000);
        }else{
          alertService.error(res.data.error);
        }
        setLoading(false);
      }).catch(err => {
        alertService.error(err);
        setLoading(false);
      });
    }else{
      alertService.error('Fill required fields');
      setLoading(false);
    }
  }
  
  useEffect(()=>{
    fetchClients(sortBy, sortOrder, 0, search, searchType);
  }, []);
  
  const onPageChange = (index_start) => {
    let lPage = index_start / global.config.items_per_page;
    setPage(lPage);
    fetchClients(sortBy, sortOrder, lPage, search, searchType);
  }

  const salutations = global.config.salutations.split(",");
  const clientTypes = global.config.clientType.split(",");
  return(
    <div className="container-fluid">
      {loading === true ? (
        <Progress label='Loading..'/>
      ):
      <div>
        <div className="card shadow mb-4">
          <div className="card-header py-3">
            <a href="#" className={'btn btn-icon-split float-right btn-'+theme()} data-toggle="modal" data-target="#createClientModal">
              <span className="icon text-white-50">
                <i className="fas fa-user-plus"></i>
              </span>
              <span className="text">Create New Client</span>
            </a>
            <h6 className={'form-group mr-3 font-weight-bold text-'+theme()}>Clients</h6>
            <div class="search-container">
              <div className={"form-group mr-3"}>
                <select name="searchType" className="form-control" value={searchType} id="searchType" onChange={(e) => setSearchType(e.target.value)}>
                  <option value="all">All</option>
                  <option value="email">Email</option>
                  <option value="mobile">Mobile</option>
                  <option value="first_name">First Name</option>
                  <option value="middle_name">Middle Name</option>
                  <option value="last_name">Last Name</option>
                  <option value="type">Type</option>
                </select>
              </div>
              <div className="form-group mr-3">
                <input name="search" value={search} className="form-control" placeholder="Search" onKeyDown={checkHandleSearch} onChange={(e) => setSearch(e.target.value)}/>
              </div>
              <div className="form-group mr-3">
                <a href="#" className="btn btn-primary btn-icon-split" onClick={handleSearch}>
                  <span className="icon">
                    <i className="fas fa-search"></i>
                  </span>
                </a>
              </div>
              {search &&
              <div className="form-group mr-3">
                <a href="#" className="btn btn-default btn-icon-split" onClick={resetSearch}>
                  <span className="icon">
                    <i className="fas fa-times"></i>
                  </span>
                </a>
              </div>
              }
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <div className="row">
                <div className="col-sm-12">
                  <table className="table table-bordered" width="100%">
                    <thead>
                      <tr>
                        <th onClick={(e) => updateSortParam(e,'first_name')}>Name <Sort field="first_name" sortBy={sortBy} sortOrder={sortOrder}/></th>
                        <th onClick={(e) => updateSortParam(e,'email')}>Email <Sort field="email" sortBy={sortBy} sortOrder={sortOrder}/></th>
                        <th onClick={(e) => updateSortParam(e,'mobile')}>Mobile <Sort field="mobile" sortBy={sortBy} sortOrder={sortOrder}/></th>
                        <th onClick={(e) => updateSortParam(e,'type')}>Type<Sort field="type" sortBy={sortBy} sortOrder={sortOrder}/></th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {clients.map(client=>
                        <ClientListItem key={client.client_id} info={client}/>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <Paginator
                itemCount={filterTotal}
                itemsPerPage={global.config.items_per_page}
                showNextPages={2}
                showPrevPages={2}
                filterTotal={filterTotal}
                grandTotal={total}
                onClick={onPageChange.bind(this)}
              />
            </div>
          </div>
        </div>
        <div className="modal fade" id="createClientModal" tabIndex="-1" role="dialog" aria-labelledby="create-popup" aria-hidden="true">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="create-popup">Create New Client</h5>
                <button className="close" type="button" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <form ref={createForm}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6 col-lg-4">
                      <div className="form-group">
                        <label>Salutation*</label>
                        <select name="salutation" className="form-control" id="salutation" onChange={handleInputChange}>
                          {salutations.map(d =>
                              <option value={d} key={d}>{d}</option>
                          )}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <div className="form-group">
                        <label>Date of Birth*</label>
                        <input type="date" maxLength="50" name="dob" className="form-control" id="dob" placeholder="Enter DOB" onChange={handleInputChange}/>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <div className="form-group">
                        <label>Anniversary Date</label>
                        <input type="date" maxLength="50" name="anniversary" className="form-control" id="anniversary" placeholder="Enter Anniversary" onChange={handleInputChange}/>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <div className="form-group">
                        <label>First Name*</label>
                        <input type="text" maxLength="50" name="first_name" className="form-control" id="first_name" placeholder="Enter First Name" onChange={handleInputChange}/>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <div className="form-group">
                        <label>Middle Name</label>
                        <input type="text" maxLength="50" name="middle_name" className="form-control" id="middle_name" placeholder="Enter Middle Name" onChange={handleInputChange}/>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <div className="form-group">
                        <label>Last Name*</label>
                        <input type="text" maxLength="50" name="last_name" className="form-control" id="last_name" placeholder="Enter Last Name" onChange={handleInputChange}/>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <div className="form-group">
                        <label>GST</label>
                        <input type="text" maxLength="50" name="gst" className="form-control" id="gst" placeholder="Enter GST" onChange={handleInputChange}/>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <div className="form-group">
                        <label>PAN*</label>
                        <input type="text" maxLength="20" name="pan" className="form-control" id="pan" placeholder="Enter PAN" onChange={handleInputChange}/>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <div className="form-group">
                        <label>Type*</label>
                        <select name="type" className="form-control" id="type" onChange={handleInputChange}>
                          {clientTypes.map(d =>
                              <option value={d} key={d}>{d}</option>
                          )}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <div className="form-group">
                        <label>Email*</label>
                        <input type="email" maxLength="50" name="email" className="form-control" id="email" placeholder="Enter Email" onChange={handleInputChange}/>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <div className="form-group">
                        <label>Mobile*</label>
                        <input type="text" maxLength="15" name="mobile" className="form-control" id="mobile" placeholder="Enter Mobile" onChange={handleInputChange}/>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <div className="form-group">
                        <label>City*</label>
                        <input type="text" maxLength="50" name="city" className="form-control" id="city" placeholder="Enter City" onChange={handleInputChange}/>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <div className="form-group">
                        <label>State*</label>
                        <input type="text" maxLength="50" name="state" className="form-control" id="state" placeholder="Enter State" onChange={handleInputChange}/>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <div className="form-group">
                        <label>Pincode*</label>
                        <input type="text" maxLength="20" name="pincode" className="form-control" id="pincode" placeholder="Enter Pincode" onChange={handleInputChange}/>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Address*</label>
                        <textarea type="text" maxLength="100" name="address" className="form-control" id="address" placeholder="Enter Address" onChange={handleInputChange}></textarea>
                      </div>
                    </div>
                  </div>
                  {loading === true ? (
                    <Progress label='Creating..' small={true}/>
                  ):null}
                </div>
                <div className="modal-footer">
                  <button className="btn btn-default" type="reset" data-dismiss="modal">Close</button>
                  <button className={'btn btn-'+theme()} type="button" onClick={handleSubmit}>Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    }
    </div>
  )
}

export default Clients;